import React from 'react';

const MenuSVG = ({ width = "24", height = "24", color = "#18191a" }) => {
  return (
    <svg 
      version="1.1" 
      id="Capa_1" 
      xmlns="http://www.w3.org/2000/svg"
      x="0px" 
      y="0px"
      viewBox="0 0 479.997 479.997"
      style={{ enableBackground: 'new 0 0 479.997 479.997' }}
      width={width}
      height={height}
      fill={color}
    >
      <g>
        <path d="M399.998,79.997h-40v-72c-0.002-4.418-3.585-7.999-8.003-7.997c-0.763,0-1.521,0.11-2.253,0.325l-272,80
          c-0.16,0-0.28,0.16-0.44,0.216c-0.407,0.165-0.801,0.363-1.176,0.592c-0.484,0.259-0.939,0.568-1.36,0.92
          c-0.31,0.288-0.599,0.598-0.864,0.928c-0.351,0.425-0.659,0.883-0.92,1.368c-0.189,0.374-0.35,0.762-0.48,1.16
          c-0.185,0.563-0.304,1.145-0.352,1.736c0,0.264-0.152,0.488-0.152,0.752v384c0,4.418,3.582,8,8,8h320c4.418,0,8-3.582,8-8v-384
          C407.998,83.578,404.417,79.997,399.998,79.997z M343.998,18.685v61.312H135.55L343.998,18.685z M391.998,463.997h-304v-368h304
          V463.997z"/>
        <path d="M183.996,127.999c-2.807,0.001-5.407,1.472-6.854,3.878l-17.144,28.568l-17.144-28.568
          c-2.277-3.786-7.192-5.01-10.979-2.733c-2.405,1.446-3.877,4.047-3.878,6.853v64c0,4.418,3.582,8,8,8s8-3.582,8-8v-35.12
          l9.144,15.24c2.595,3.786,7.769,4.752,11.555,2.157c0.846-0.58,1.577-1.311,2.157-2.157l9.144-15.24v35.12c0,4.418,3.582,8,8,8
          s8-3.582,8-8v-64C191.997,131.578,188.414,127.998,183.996,127.999z"/>
        <path d="M231.998,175.997c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16v-16h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-24
          c-4.418,0-8,3.582-8,8v64c0,4.418,3.582,8,8,8h24c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16v-16H231.998z"/>
        <path d="M287.998,127.997c-4.418,0-8,3.582-8,8v30.112l-16.8-33.688c-1.925-3.977-6.71-5.64-10.687-3.714
          c-2.79,1.351-4.548,4.191-4.513,7.29v64c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8v-30.112l16.8,33.688
          c1.925,3.977,6.71,5.64,10.687,3.714c2.79-1.351,4.548-4.191,4.513-7.29v-64C295.998,131.578,292.417,127.997,287.998,127.997z"/>
        <path d="M343.998,127.997c-4.418,0-8,3.582-8,8v48c0,4.418-3.582,8-8,8s-8-3.582-8-8v-48c0-4.418-3.582-8-8-8s-8,3.582-8,8v48
          c0,13.255,10.745,24,24,24s24-10.745,24-24v-48C351.998,131.578,348.417,127.997,343.998,127.997z"/>
        <path d="M367.998,279.997h-256c-4.418,0-8,3.582-8,8s3.582,8,8,8h256c4.418,0,8-3.582,8-8S372.417,279.997,367.998,279.997z"/>
        <path d="M367.998,327.997h-256c-4.418,0-8,3.582-8,8s3.582,8,8,8h256c4.418,0,8-3.582,8-8S372.417,327.997,367.998,327.997z"/>
        <path d="M367.998,375.997h-256c-4.418,0-8,3.582-8,8s3.582,8,8,8h256c4.418,0,8-3.582,8-8S372.417,375.997,367.998,375.997z"/>
      </g>
    </svg>
  );
};

export default MenuSVG; 